import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Page } from 'react-pdf';
import { Document } from 'react-pdf/dist/esm/entry.webpack';

const ViewPdfFile = (props) => {
  const [pdfStatus, setPdfStatus] = useState({pageCount: 0, currentPage: 1 })

  const onLoadSuccess = ({ numPages }) => {
    setPdfStatus({ ...pdfStatus, pageCount: numPages });
  }

  const onPrevPage = () => {
    var page = pdfStatus.currentPage;
    if (page > 1) {
      setPdfStatus({ ...pdfStatus, currentPage: page - 1 });
    }

  }

  const onNextPage = () => {
    var page = pdfStatus.currentPage;
    if (page < pdfStatus.pageCount) {
      setPdfStatus({ ...pdfStatus, currentPage: page + 1 });
    }
  }

  const onClose = () => {
    setPdfStatus({ pageCount: 0, currentPage: 1 });
    props.onClose();
  }

  return (
    <div>
      <Dialog scroll='body' open={props.open} maxWidth='xl'>
        <DialogTitle>{props.fileName}</DialogTitle>
        <DialogContent>
          <Document file={props.pdf} onLoadSuccess={onLoadSuccess} onLoadError={(err) => (console.log(`onLoadError --> ${err}`))}>
            <Page pageNumber={pdfStatus.currentPage} />
          </Document>
        </DialogContent>
        <DialogActions>
          <Button onClick={onPrevPage} disabled={pdfStatus.currentPage === 1}>Prev</Button>
          <p>{pdfStatus.currentPage} of {pdfStatus.pageCount}</p>
          <Button onClick={onNextPage} disabled={pdfStatus.currentPage === pdfStatus.pageCount}>Next</Button>
          <Button onClick={onClose} >Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

ViewPdfFile.propTypes = {
  open: PropTypes.bool.isRequired,
  pdf: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ViewPdfFile;